import { axiosInstance } from "../../axios/axiosInstance";
import { getPreviousPath } from "./routeTrail";

let pendingShipServiceKey = null;
let pendingCardUuid = null;
let pendingPaymentType = null;
let pendingDeliveryMethod = null;
let pendingShippingAddress = null;
let pendingOrderCommentsOpen = false;
let restoreOutcome = null;
let suppressAutoScroll = false;
let cardReentryNotice = false;

export const fetchTillCheckoutState = async (orderId) => {
  if (orderId == null || orderId === "") return null;
  try {
    const response = await axiosInstance.get("Shipping/TillCheckoutState", { params: { orderId: String(orderId) } });
    const raw = response && response.data ? response.data.data : null;
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (err) {
    return null;
  }
};

export const settleTillCheckoutAsCancel = ({ orderId, userId }) => {
  if (orderId == null || orderId === "") return false;
  axiosInstance
    .post("Shipping/TillPaymentSuccess", {
      marchentid: "",
      paystatus: "cancel",
      userid: String(userId || ""),
      orderid: String(orderId),
      savecard: false,
    })
    .catch(() => {
      /* the gateway postback remains the backstop */
    });
  return true;
};

export const setPendingRestoreTargets = ({
  shipServiceKey,
  cardUuid,
  paymentType,
  deliveryMethod,
  shippingAddress,
  orderCommentsOpen,
}) => {
  pendingShipServiceKey = shipServiceKey == null ? null : shipServiceKey;
  pendingCardUuid = cardUuid == null ? null : cardUuid;
  pendingPaymentType = paymentType == null ? null : paymentType;
  pendingDeliveryMethod = deliveryMethod == null ? null : deliveryMethod;
  pendingShippingAddress = shippingAddress == null ? null : shippingAddress;
  pendingOrderCommentsOpen = orderCommentsOpen === true;
};

export const clearPendingRestoreTargets = () => {
  pendingShipServiceKey = null;
  pendingCardUuid = null;
  pendingPaymentType = null;
  pendingDeliveryMethod = null;
  pendingShippingAddress = null;
  pendingOrderCommentsOpen = false;
};

export const takePendingShipServiceKey = () => {
  const key = pendingShipServiceKey;
  pendingShipServiceKey = null;
  return key;
};

export const takePendingCardUuid = () => {
  const uuid = pendingCardUuid;
  pendingCardUuid = null;
  return uuid;
};

export const takePendingPaymentType = () => {
  const type = pendingPaymentType;
  pendingPaymentType = null;
  return type;
};

export const takePendingDeliveryMethod = () => {
  const method = pendingDeliveryMethod;
  pendingDeliveryMethod = null;
  return method;
};

export const takePendingShippingAddress = () => {
  const address = pendingShippingAddress;
  pendingShippingAddress = null;
  return address;
};

export const takePendingOrderCommentsOpen = () => {
  const open = pendingOrderCommentsOpen;
  pendingOrderCommentsOpen = false;
  return open;
};

export const setRestoreOutcome = (outcome) => {
  restoreOutcome = outcome;
};

export const takeRestoreOutcome = () => {
  const outcome = restoreOutcome;
  restoreOutcome = null;
  return outcome;
};

export const setSuppressAutoScroll = (value) => {
  suppressAutoScroll = value;
};

export const shouldSuppressAutoScroll = () => suppressAutoScroll;

export const setCardReentryNotice = (value) => {
  cardReentryNotice = value;
};

export const takeCardReentryNotice = () => {
  const notice = cardReentryNotice;
  cardReentryNotice = false;
  return notice;
};

const TILL_BACK_PATH_KEY = "wes.till.backPath";

export const readTillBackPath = () => {
  try {
    return window.sessionStorage.getItem(TILL_BACK_PATH_KEY) || null;
  } catch (err) {
    return null;
  }
};

const rememberTillBackPath = () => {
  try {
    const previous = getPreviousPath();
    if (previous) window.sessionStorage.setItem(TILL_BACK_PATH_KEY, previous);
    else window.sessionStorage.removeItem(TILL_BACK_PATH_KEY);
  } catch (err) {
    /* storage unavailable */
  }
};

export const redirectToTill = (url) => {
  if (process.env.NODE_ENV !== "production") {
    const expected = "https://localhost:44366";
    if (window.location.origin !== expected) {
      console.warn(
        `[till] Return URLs are built from baseDirectory (${expected}) but this page is on ${window.location.origin}. ` +
          `Browse the app at ${expected}, or set spaBaseDirectory in appsettings.`,
      );
    }
  }
  rememberTillBackPath();
  window.location.assign(url);
};
